// Craft / DIY category step images

import carveKitchenToolCh3S3 from '@/assets/step-images/carve-kitchen-tool-ch3-s3.jpg';
import crochetMatchingSetCh1S5 from '@/assets/step-images/crochet-matching-set-ch1-s5.jpg';
import crochetMatchingSetCh3S2 from '@/assets/step-images/crochet-matching-set-ch3-s2.jpg';
import crossStitchCh3S4 from '@/assets/step-images/cross-stitch-ch3-s4.jpg';
import customCandleCh1S1 from '@/assets/step-images/custom-candle-ch1-s1.jpg';
import customCandleCh3S3 from '@/assets/step-images/custom-candle-ch3-s3.jpg';
import customCandleCh3S5 from '@/assets/step-images/custom-candle-ch3-s5.jpg';
import customJewelryCh1S1 from '@/assets/step-images/custom-jewelry-ch1-s1.jpg';
import customJewelryCh1S3 from '@/assets/step-images/custom-jewelry-ch1-s3.jpg';
import customPhotoFrameCh1S5 from '@/assets/step-images/custom-photo-frame-ch1-s5.jpg';
import customPhotoFrameCh2S1 from '@/assets/step-images/custom-photo-frame-ch2-s1.jpg';
import customPhotoFrameCh3S2 from '@/assets/step-images/custom-photo-frame-ch3-s2.jpg';
import customRingCh1S1 from '@/assets/step-images/custom-ring-ch1-s1.jpg';
import customRingCh1S2 from '@/assets/step-images/custom-ring-ch1-s2.jpg';
import customRingCh3S4 from '@/assets/step-images/custom-ring-ch3-s4.jpg';
import customRingCh3S5 from '@/assets/step-images/custom-ring-ch3-s5.jpg';
import customToteBagCh3S5 from '@/assets/step-images/custom-tote-bag-ch3-s5.jpg';
import flowerArrangementCh1S1 from '@/assets/step-images/flower-arrangement-ch1-s1.jpg';
import flowerArrangementCh3S1 from '@/assets/step-images/flower-arrangement-ch3-s1.jpg';
import flowerArrangementCh3S4 from '@/assets/step-images/flower-arrangement-ch3-s4.jpg';
import handmadeKitchenSetCh1S3 from '@/assets/step-images/handmade-kitchen-set-ch1-s3.jpg';
import handmadeKitchenSetCh1S5 from '@/assets/step-images/handmade-kitchen-set-ch1-s5.jpg';
import handmadeKitchenSetCh3S4 from '@/assets/step-images/handmade-kitchen-set-ch3-s4.jpg';
import handmadeKitchenSetCh3S5 from '@/assets/step-images/handmade-kitchen-set-ch3-s5.jpg';
import miniWallArtSetCh2S5 from '@/assets/step-images/mini-wall-art-set-ch2-s5.jpg';
import miniWallArtSetCh3S1 from '@/assets/step-images/mini-wall-art-set-ch3-s1.jpg';
import tabletopDecorCh1S5 from '@/assets/step-images/tabletop-decor-ch1-s5.jpg';
import tabletopDecorCh2S5 from '@/assets/step-images/tabletop-decor-ch2-s5.jpg';
import tabletopDecorCh3S4 from '@/assets/step-images/tabletop-decor-ch3-s4.jpg';
import terrariumCh1S1 from '@/assets/step-images/terrarium-ch1-s1.jpg';
import terrariumCh3S5 from '@/assets/step-images/terrarium-ch3-s5.jpg';
import upcycleDecorObjectCh1S1 from '@/assets/step-images/upcycle-decor-object-ch1-s1.jpg';
import upcycleDecorObjectCh2S5 from '@/assets/step-images/upcycle-decor-object-ch2-s5.jpg';
import upcycleDecorObjectCh3S4 from '@/assets/step-images/upcycle-decor-object-ch3-s4.jpg';
import upcycleFurnitureAccentCh1S2 from '@/assets/step-images/upcycle-furniture-accent-ch1-s2.jpg';
import upcycleFurnitureAccentCh1S5 from '@/assets/step-images/upcycle-furniture-accent-ch1-s5.jpg';
import upcycleFurnitureAccentCh2S1 from '@/assets/step-images/upcycle-furniture-accent-ch2-s1.jpg';
import upcycleFurnitureAccentCh2S3 from '@/assets/step-images/upcycle-furniture-accent-ch2-s3.jpg';
import upcycleFurnitureAccentCh2S5 from '@/assets/step-images/upcycle-furniture-accent-ch2-s5.jpg';
import upcycleFurnitureAccentCh3S2 from '@/assets/step-images/upcycle-furniture-accent-ch3-s2.jpg';
import upcycleFurnitureAccentCh3S5 from '@/assets/step-images/upcycle-furniture-accent-ch3-s5.jpg';
import upcycleWoodStainCh1S1 from '@/assets/step-images/upcycle-wood-stain-ch1-s1.jpg';
import upcycleWoodStainCh2S4 from '@/assets/step-images/upcycle-wood-stain-ch2-s4.jpg';
import upcycleWoodStainCh3S1 from '@/assets/step-images/upcycle-wood-stain-ch3-s1.jpg';
import upcycleWoodStainCh3S3 from '@/assets/step-images/upcycle-wood-stain-ch3-s3.jpg';
import woodenSpoonCh1S1 from '@/assets/step-images/wooden-spoon-ch1-s1.jpg';

export const CRAFT_IMAGES: Record<string, string> = {
  'carve-kitchen-tool-ch3-s3': carveKitchenToolCh3S3,
  'crochet-matching-set-ch1-s5': crochetMatchingSetCh1S5,
  'crochet-matching-set-ch3-s2': crochetMatchingSetCh3S2,
  'cross-stitch-ch3-s4': crossStitchCh3S4,
  'custom-candle-ch1-s1': customCandleCh1S1,
  'custom-candle-ch3-s3': customCandleCh3S3,
  'custom-candle-ch3-s5': customCandleCh3S5,
  'custom-jewelry-ch1-s1': customJewelryCh1S1,
  'custom-jewelry-ch1-s3': customJewelryCh1S3,
  'custom-photo-frame-ch1-s5': customPhotoFrameCh1S5,
  'custom-photo-frame-ch2-s1': customPhotoFrameCh2S1,
  'custom-photo-frame-ch3-s2': customPhotoFrameCh3S2,
  'custom-ring-ch1-s1': customRingCh1S1,
  'custom-ring-ch1-s2': customRingCh1S2,
  'custom-ring-ch3-s4': customRingCh3S4,
  'custom-ring-ch3-s5': customRingCh3S5,
  'custom-tote-bag-ch3-s5': customToteBagCh3S5,
  'flower-arrangement-ch1-s1': flowerArrangementCh1S1,
  'flower-arrangement-ch3-s1': flowerArrangementCh3S1,
  'flower-arrangement-ch3-s4': flowerArrangementCh3S4,
  'handmade-kitchen-set-ch1-s3': handmadeKitchenSetCh1S3,
  'handmade-kitchen-set-ch1-s5': handmadeKitchenSetCh1S5,
  'handmade-kitchen-set-ch3-s4': handmadeKitchenSetCh3S4,
  'handmade-kitchen-set-ch3-s5': handmadeKitchenSetCh3S5,
  'mini-wall-art-set-ch2-s5': miniWallArtSetCh2S5,
  'mini-wall-art-set-ch3-s1': miniWallArtSetCh3S1,
  'tabletop-decor-ch1-s5': tabletopDecorCh1S5,
  'tabletop-decor-ch2-s5': tabletopDecorCh2S5,
  'tabletop-decor-ch3-s4': tabletopDecorCh3S4,
  'terrarium-ch1-s1': terrariumCh1S1,
  'terrarium-ch3-s5': terrariumCh3S5,
  'upcycle-decor-object-ch1-s1': upcycleDecorObjectCh1S1,
  'upcycle-decor-object-ch2-s5': upcycleDecorObjectCh2S5,
  'upcycle-decor-object-ch3-s4': upcycleDecorObjectCh3S4,
  'upcycle-furniture-accent-ch1-s2': upcycleFurnitureAccentCh1S2,
  'upcycle-furniture-accent-ch1-s5': upcycleFurnitureAccentCh1S5,
  'upcycle-furniture-accent-ch2-s1': upcycleFurnitureAccentCh2S1,
  'upcycle-furniture-accent-ch2-s3': upcycleFurnitureAccentCh2S3,
  'upcycle-furniture-accent-ch2-s5': upcycleFurnitureAccentCh2S5,
  'upcycle-furniture-accent-ch3-s2': upcycleFurnitureAccentCh3S2,
  'upcycle-furniture-accent-ch3-s5': upcycleFurnitureAccentCh3S5,
  'upcycle-wood-stain-ch1-s1': upcycleWoodStainCh1S1,
  'upcycle-wood-stain-ch2-s4': upcycleWoodStainCh2S4,
  'upcycle-wood-stain-ch3-s1': upcycleWoodStainCh3S1,
  'upcycle-wood-stain-ch3-s3': upcycleWoodStainCh3S3,
  'wooden-spoon-ch1-s1': woodenSpoonCh1S1,
};
